import React, { Component } from 'react'
import styled from 'styled-components'
import { Button, Select, TextInput } from 'advenio-components'
import { Form as OriginalForm } from 'formsy-react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 300px;
  width: 80%;
  margin-bottom: 10px;

  @media (max-width: 763px) {
    margin-bottom: 300px;
  }
`
const Form = styled(OriginalForm)`
  width: 100%;
`

class Incident extends Component {
  state = {
    incidentOptions: [],
    medicationOptions: [],
    info: '',
  }

  componentWillMount() {
    const { incidentTypes, medicationTypes } = this.props

    if (incidentTypes && incidentTypes.length) {
      this.generateIncidentOptions()
    }

    if (medicationTypes && medicationTypes.length) {
      this.generateMedicationOptions()
    }
  }

  onChange = (formData) => {
    const params = { ...formData }
    params.category_id = this.props.category

    this.props.setExtraData(params)
  }

  onClick = () => this.props.goToView('kidsToSleep', this.props.view, '')

  generateIncidentOptions = () => {
    this.setState({ incidentOptions: this.generateOptions(this.props.incidentTypes) })
  }

  generateMedicationOptions = () => {
    this.setState({ medicationOptions: this.generateOptions(this.props.medicationTypes) })
  }

  generateOptions = options => (
    options.map(option => ({
      id: option.id,
      label: option.name,
      value: option.id,
    }))
  )

  render() {
    const { incidentOptions, medicationOptions } = this.state

    return (
      <Container>
        <Form onChange={this.onChange}>
          <Select
            label="Tipo de Incidente"
            name="type_id"
            options={incidentOptions}
          />
          <Select
            emptyElement
            label="Medicamento Aplicado"
            name="medication_id"
            options={medicationOptions}
          />
          <TextInput
            textarea
            label="Comentarios"
            name="description"
            value=""
          />
        </Form>
        {this.props.isGroupActivity && (
          <Button
            primary
            style={{ marginTop: '40px', width: '150px' }}
            onClick={this.onClick}
          >
            Agregar alumnos
          </Button>
        )}
      </Container>
    )
  }
}

Incident.propTypes = {
  /** The ID of the activity type to be registered */
  category: PropTypes.number,
  /** The listing of available incident types to be reported */
  incidentTypes: PropTypes.array,
  /** The listing of available medication types that can be applied to the student */
  medicationTypes: PropTypes.array,
  /** Flag marking whether the activity being registered is for a group of students */
  isGroupActivity: PropTypes.bool,
  /** The current view */
  view: PropTypes.string,

  /** Callback function to navigate to the specified view */
  goToView: PropTypes.func.isRequired,
  /** Callback function to retrieve information */
  setExtraData: PropTypes.func.isRequired,
}

Incident.defaultProps = {
  category: null,
  incidentTypes: [],
  medicationTypes: [],
  isGroupActivity: false,
  view: '',
}

const mapStateToProps = ({ emergencyMedications, incidentTypes }) => ({
  incidentTypes: incidentTypes.get.results,
  medicationTypes: emergencyMedications.get.results,
  loading: emergencyMedications.get.fetching || incidentTypes.get.fetching,
})

const mapDispatchToProps = () => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(Incident)



// WEBPACK FOOTER //
// ./src/Components/Activity/Incident.jsx